import BaseComponent from 'foundation/base-component';
import Cookies from 'js-cookie';
import isEmpty from 'lodash/isEmpty';
import overlay from '../../../general/js/overlay';

const COOKIE_WARNING_AGREED = 'cookie-warning-settings_agreed';
const COOKIE_WARNING_AGREE_BUTTON_CLASS = 'cookie-warning__agree-button';
const COOKIE_WARNING_AGREE_LINK_CLASS = 'cookie-warning__agree-link';
const COOKIE_CONTROL_EXPIRY_DAYS = 'cookieControlExpiryDaysValue';

export default class CookieWarningComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.onCloseCookieWarning = this.onCloseCookieWarning.bind(this);
        this.closeSlideoutCookiePanelHandler = this.closeSlideoutCookiePanelHandler.bind(this);
        this.acceptCookiesHandler = this.acceptCookiesHandler.bind(this);
        
        this.handleDelegatedClicks = this.handleDelegatedClicks.bind(this); 

        this.cookieWarningSettingsAgreedTitle = this.getCookieWarningOption('warningSettingsAgreed', COOKIE_WARNING_AGREED);
        this.requiredCookiesForGoogleAnalytics = this.getCookieWarningOption('requiredCookiesForGoogleAnalytics');
        this.init();
    }

    isSiteVisited() {
        const warningAgreedCookie = Cookies.get(this.cookieWarningSettingsAgreedTitle);
        return warningAgreedCookie !== undefined;
    }

    init() {
        setTimeout(() => {
            if (!this.isSiteVisited()) {
                
                if (!document.getElementById('cookie-shield-style')) {
                    const style = document.createElement('style');
                    style.id = 'cookie-shield-style';
                    style.innerHTML = `
                        body.force-cookie-banner-visible .cookie-warning { 
                            display: block !important; 
                            opacity: 1 !important; 
                            visibility: visible !important; 
                            z-index: 999999 !important;
                        }
                        body.force-cookie-banner-hidden .cookie-warning {
                            display: none !important;
                        }
                    `;
                    document.head.appendChild(style);
                }

                document.body.classList.add('force-cookie-banner-visible');
                overlay.show('overlay');

                document.body.addEventListener('click', this.handleDelegatedClicks);
            }
        }, 100);
    }

    handleDelegatedClicks(e) {
        if (e.target.closest(`.${COOKIE_WARNING_AGREE_BUTTON_CLASS}`)) {
            e.preventDefault();
            const cookieExpiryDays = this.getCookieExpiryDays();
            Cookies.set(this.cookieWarningSettingsAgreedTitle, '1', { expires: cookieExpiryDays, secure: true });
            
            if (typeof window.CookieControl !== 'undefined' && window.CookieControl.notifyAccept) {
                window.CookieControl.notifyAccept();
            }
            this.onCloseCookieWarning();
            return;
        }

        if (e.target.closest(`.${COOKIE_WARNING_AGREE_LINK_CLASS}`)) {
            // CRITICAL: No preventDefault() here so the native href opens the Civic Panel
            this.onCloseCookieWarning();
            return;
        }
    }

    onCloseCookieWarning() {
        setTimeout(() => {
            const { civicukCloseButtonId, civicukAcceptAllButtonId } = this.options;
            let slideoutCloseButton = null;
            let acceptAllButton = null; 

            if (civicukCloseButtonId !== undefined && !isEmpty(civicukCloseButtonId)) {
                slideoutCloseButton = document.getElementById(civicukCloseButtonId);
            }

            if (civicukAcceptAllButtonId !== undefined && !isEmpty(civicukAcceptAllButtonId)) {
                acceptAllButton = document.getElementById(civicukAcceptAllButtonId);
            }

            this.addClickEventListener(slideoutCloseButton, this.closeSlideoutCookiePanelHandler);
            this.addClickEventListener(acceptAllButton, this.acceptCookiesHandler);

            document.body.removeEventListener('click', this.handleDelegatedClicks);
            document.body.classList.remove('force-cookie-banner-visible');
            document.body.classList.add('force-cookie-banner-hidden');
            
            overlay.hide('overlay');
        }, 300);
    }

    addClickEventListener(element, callback) {
        if (element !== null) {
            element.addEventListener('click', callback, { once: true });
        }
    }

    getCookieExpiryDays() {
        let cookieExpiryDays = parseInt(localStorage.getItem(COOKIE_CONTROL_EXPIRY_DAYS));
        
        if (isNaN(cookieExpiryDays) || cookieExpiryDays === null || cookieExpiryDays === undefined) {
            cookieExpiryDays = 90;
        }

        return cookieExpiryDays;
    }

    closeSlideoutCookiePanelHandler() {
        const cookieExpiryDays = this.getCookieExpiryDays();
        const cookieControlValue = Cookies.get('CookieControl');
        const cookieControlObj = !isEmpty(cookieControlValue) ? JSON.parse(cookieControlValue) : {};
        let cookieWarningAgreedValue = '0';

        if (this.requiredCookiesForGoogleAnalytics && !isEmpty(cookieControlObj) && !isEmpty(cookieControlObj.optionalCookies)) {
            this.requiredCookiesForGoogleAnalytics.forEach(requiredCookie => {
                if (Object.keys(cookieControlObj.optionalCookies).some((optionalCookie) => optionalCookie === requiredCookie)) {
                    cookieWarningAgreedValue = '1';
                }
            });
        }

        Cookies.set(this.cookieWarningSettingsAgreedTitle, cookieWarningAgreedValue, { expires: cookieExpiryDays, secure: true });
    }

    acceptCookiesHandler() {
        Cookies.set(this.cookieWarningSettingsAgreedTitle, '1', { expires: this.getCookieExpiryDays(), secure: true });
    }

    getCookieWarningOption(optionName, defaultValue = undefined) {
        return this.options ? this.options[optionName] : defaultValue;
    }
}